module.exports = require("blueimp-md5");;